import { P as Popover } from "./index.chunk.js";
const flowbite_min = "";
const $targetEl = document.getElementById("popover-description");
const $triggerEl = document.getElementById("popoverButton");
const options = {
  placement: "top",
  triggerType: "hover",
  offset: 10
};
if ($targetEl) {
  const popover = new Popover(
    $targetEl,
    $triggerEl,
    options
  );
  popover.show();
}
